import React from "react";
import { Tabs, Tab, Box } from "@mui/material";

export default function PlaygroundHeader({
  selectedButton,
  setSelectedButton,
  insights,
  setInsights,
  selectedTab,
  handleTabChange,
  videoCitations,
  documentCitations,
}) {
  const tabStyle = {
    fontWeight: 600,
    fontSize: "16px",
    textTransform: "none",
    color: "#ADADAD",
    "&.Mui-selected": {
      color: "#525252",
    },
  };

  return (
    <div className="playground-header">
      <Box sx={{ borderColor: "divider" }} className="chat-panel-header">
        <Tabs
          value={selectedTab}
          onChange={handleTabChange}
          aria-label="basic tabs example"
          textColor="inherit"
          sx={{
            "& .MuiTabs-indicator": {
              backgroundColor: "white",
              height: "4px",
            },
          }}
        >
          <Tab label="Enhanced Search Results" sx={tabStyle} />
          {videoCitations?.length > 0 && (
            <Tab
              label={`Videos (${
                new Set(videoCitations.map((citation) => citation.content_id))
                  .size
              })`}
              sx={tabStyle}
            />
          )}
          {documentCitations?.length > 0 && (
            <Tab
              label={`Documents (${
                new Set(
                  documentCitations.map((citation) => citation.content_id)
                ).size
              })`}
              sx={tabStyle}
            />
          )}
        </Tabs>
      </Box>
      {/* 
      <h4>Prompt Engineering Playground</h4>
      <div className="playground-header-buttons">
        <button
          className={`button-default ${
            selectedButton === "single-view" ? "button-selected" : ""
          }`}
          onClick={() => setSelectedButton("single-view")}
        >
          Single View
        </button>
        <button
          className={`button-default ${
            selectedButton === "multi-view" ? "button-selected" : ""
          }`}
          onClick={() => setSelectedButton("multi-view")}
        >
          Side by Side View
        </button>
        <div>
          <CheckboxInputField
            title="Insights"
            value={insights}
            onChange={() => setInsights(!insights)}
            maxLength={100}
          />
        </div> 
      </div>*/}
    </div>
  );
}
